import React from 'react';
import { BrowserRouter } from 'react-router-dom'

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={window.__POWERED_BY_QIANKUN__ ? '/inventory' : '/'}>
        React(MicroApp) Inventory
      </BrowserRouter>
    </div>
  );
}

export default App;
